import React, { useState } from 'react'
import PropTypes from 'prop-types'

import colors from '@settings/styleSettings'
import TextInput from '@components/inputs/textInput'
import Label from '@components/inputs/label'

import 'material-icons/iconfont/outlined.css'

import {
  Container,
  InputContainer,
  IconContainer,
  EyeContainer,
  ContainerError,
  VisibilityIcon,
  VisibilityOffIcon,
} from './styles'

const FormInput = ({
  type,
  value,
  placeholder,
  label,
  required,
  onChange,
  onBlur,
  style,
  disabled,
  maxLength,
  error,
  inputParams
}) => {
  const [showPassword, setShowPassword] = useState(false)

  const errorMessage = (
    <ContainerError>
      <span className="material-icons-outlined" style={{ color: colors.strongRed, fontSize: 16 }}>error</span>
      {error}
    </ContainerError>

  )

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }

  const passwordIcon = () => {
    if (type !== 'password') return null
    const EyeIcon = showPassword
      ? <VisibilityIcon className="material-icons-outlined" error={error}>visibility</VisibilityIcon>
      : <VisibilityOffIcon className="material-icons-outlined" error={error}>visibility_off</VisibilityOffIcon>

    return (
      <EyeContainer
        onClick={togglePasswordVisibility}
        style={{ cursor: 'pointer' }}
      >
        {EyeIcon}
      </EyeContainer>
    )
  }

  return (
    <Container>
      {label && (
        <Label
          error={error}
          label={label}
          required={required}
        />
      )}
      <InputContainer>
        <TextInput
          type={showPassword ? 'text' : type}
          maxLength={maxLength}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          style={type === 'password' ? { ...style, paddingRight: '40px' } : style}
          placeholderTextColor={colors.strongGray}
          disabled={disabled}
          mode="outlined"
          error={error}
          inputParams={inputParams}
        />
        <IconContainer>{passwordIcon()}</IconContainer>
      </InputContainer>
      {error ? errorMessage : null}
    </Container>
  )
}

FormInput.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  type: PropTypes.string,
  style: PropTypes.shape({}),
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  maxLength: PropTypes.number,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  inputParams: PropTypes.object,
}

FormInput.defaultProps = {
  maxLength: null,
  value: '',
  placeholder: '',
  label: null,
  type: null,
  required: false,
  style: null,
  onBlur: () => {},
  disabled: false,
  error: undefined,
  inputParams: {}
}

export default FormInput
